module.exports = __webpack_public_path__ + "ebda938379a3b9aa7ebfad53264eeb32.svg";